<template>
  <div id="app">
    <AppHeader></AppHeader>
    <SubNav v-if="subNavVisible"></SubNav>
    <router-view />
    <AppFooter></AppFooter>
  </div>
</template>

<script>
// 引入头部和尾部组件
import AppHeader from "./components/Header.vue"
import AppFooter from "./components/footer.vue"
import SubNav from "./components/SubNav.vue";
export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    SubNav
  },
  data() {
    return {
      subNavVisible: false, // 控制子导航的显示和隐藏
    }
  },
  created() {
    // 初始化时根据当前路由设置子导航的显示状态
    this.subNavVisible = !this.$route.path.includes('/index');
  },
  watch: {
    '$route' (to, from) {
      // 当路由变化时，判断是否需要显示子导航
      this.subNavVisible = !to.path.includes('/index');
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue